import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";

import Deployment_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Deployment_&_Maintenance.svg";
import Design_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Design_&_Prototyping.svg";
import GameDevelopment from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Game Development.svg";
import Requirement_Analysis from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Requirement_Analysis.svg";
import Testing_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Testing_&_Quality.svg";

import Achivement from "../../../assets/Services/Arcade_dev/Features/Achivement.png";
import Multiple_games from "../../../assets/Services/Arcade_dev/Features/Multiple_games.png";
import Real_time from "../../../assets/Services/Arcade_dev/Features/Real_time.png";
import cross_platform from "../../../assets/Services/Arcade_dev/Features/cross_platform.png";
import socail_media from "../../../assets/Services/Arcade_dev/Features/socail_media.png";

import Demand_Analysis_Planning from "../../../assets/Services/Arcade_dev/Our_Development_Methodology/Demand_Analysis_Planning.svg";
import Deployment_Live from "../../../assets/Services/Arcade_dev/Our_Development_Methodology/Deployment_Live Operations.svg";
import Design_Prototyping from "../../../assets/Services/Arcade_dev/Our_Development_Methodology/Design_Prototyping.svg";
import Development_Integration from "../../../assets/Services/Arcade_dev/Our_Development_Methodology/Development_Integration.svg";
import Testing_Quality_Assurance from "../../../assets/Services/Arcade_dev/Our_Development_Methodology/Testing_Quality_Assurance.svg";

import Maskgroup from "../../../assets/Services/Arcade_dev/Client/Mask _group3.png";
import Maskgroup2 from "../../../assets/Services/Arcade_dev/Client/Mask_group.png";
import Maskgroup3 from "../../../assets/Services/Arcade_dev/Client/Maskgroup.png";

import Powered_Gaming_Intelligence from "../../../assets/Services/Arcade_dev/Raiden_labs_arcade_dev/AI-Powered_Gaming_Intelligence.svg";
import Cutting from "../../../assets/Services/Arcade_dev/Raiden_labs_arcade_dev/Cutting-Edge_Technology_Integration.svg";
import Global_Market_Expertise from "../../../assets/Services/Arcade_dev/Raiden_labs_arcade_dev/Global_Market_Expertise.svg";
import GameDevelopments from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Game Development.svg'

import Rummy_Game_Development from "../../../assets/Services/Arcade_dev/Rummy_Game_Development.png";
import Unreal_Engine_Development from "../../../assets/Services/Arcade_dev/Unreal_Engine_Development.png";


import Arcade_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png";
import Bingo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png";
import Board_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png";
import Ludo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png";
// import Rummy_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png";
import Poker_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png";


import BCKEND_DEV from '../../../assets/Services/Arcade_dev/img/BCKEND_DEV&CLOUD.png'
import Custom_arcade from '../../../assets/Services/Arcade_dev/img/Custom_arcade.png'
import Multiplayer_functionality from '../../../assets/Services/Arcade_dev/img/Multiplayer_functionality.png'
import Post_launch_support from '../../../assets/Services/Arcade_dev/img/Post_launch_support.png'
import Social_features from '../../../assets/Services/Arcade_dev/img/Social_features.png'

import big from '../../../assets/Services/Game_page/Arcade/big.png'
import icon from '../../../assets/Services/Game_page/Arcade/one.png'
import icon2 from '../../../assets/Services/Game_page/Arcade/two.png'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";
const ArcadeGameDev = () => {
   const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: "Custom Arcade Game Design ",
      desc: "Our expert creators produce engaging and intuitive hall game interfaces with customizable visual themes, character designs, and environmental aesthetics. We concentrate on stoner experience optimization, icing responsive controls, smooth animations, and addicting gameplay mechanics across all bias.  ",
      img: Custom_arcade,
    },
    {
      title: "Multiplayer Functionality & Real- Time Competition ",
      desc: "Develop robust multiplayer hall gests with real- time synchronization, allowing multiple players to contend simultaneously in events, battles, and collaborative challenges. Our advanced networking results support ranked matchmaking, onlooker modes, and competitive leaderboards with global rankings.  ",
      img: Multiplayer_functionality,
    },
 
 
 
    {
      title: "Backend Development & Cloud structure ",
      desc: "  figure scalable garçon armature using AWS, Google Cloud, or Azure to handle millions of concurrent players with minimum quiescence. Our robust backend systems manage stoner biographies, real- time scoring, global leaderboards, and multiplayer matchmaking with 99.9 uptime guarantee.",
      img: BCKEND_DEV,
    },
    {
      title: " Social Features & Community Building",
      desc: " Integrate comprehensive social networking capabilities including friend systems, guild formations, chat functionality, and community events. Players can produce brigades, share in seasonal events, and engage in competitive leagues that foster long- term community engagement. ",
      img: Social_features,
    },
    {
      title: " Post-Launch Support & Live Operations",
      desc: " give ongoing specialized support, regular content updates, seasonal events, and point advancements to keep your hall games competitive. Our devoted live operations platoon ensures fresh content delivery, community operation, and rapid-fire response to player feedback and specialized issues. ",
      img:Post_launch_support ,
    },
  ];

  const pokerdevcompany2 = [
    {
      title: "   Demand Analysis & Planning",
      icon: Demand_Analysis_Planning,
      desc: `We start by understanding your vision, analyzing your target audience, and setting a clear design direction.
Our team makes sure your game fits your brand, meets your goals, and includes modern features like real-time multiplayer, achievement systems, and monetization strategies.
`,
    },
    {
      title: " Design & Prototyping  ",
      icon: Design_Prototyping,
      desc: "  Our team creates detailed wireframes, character designs, and interactive prototypes.We focus on easy-to-use controls and exciting visuals. We also make sure the gameplay works smoothly on all devices, from mobile phones to game consoles, and offer great visuals and smooth user experience. ",
    },
    {
      title: "  Development & Integration ",
      icon: Development_Integration,
      desc: " Our developers use top technologies to bring your game to life.We add advanced features such as immersive gameplay, real-time multiplayer, social features, secure payment systems, and high-performance graphics. This gives players an exciting and fun gaming experience that keeps them coming back.  ",
    },
    {
      title: " Testing & Quality Assurance  ",
      icon:Testing_ ,
      desc: " We test the game thoroughly to make sure it works well on all platforms.We conduct various tests including checking how well it performs, testing multiplayer features, and making sure it complies with platform rules. Our goal is to give you a game with no bugs, balanced difficulty, and stable online play. ",
    },
    {
      title: "Deployment & Live Operations   ",
      icon:Deployment_ ,
      desc: "   After testing, we launch the game on all platforms and provide ongoing support.Our team makes sure the game stays fresh with regular updates, new events, community engagement, and performance checks, keeping players interested and playing for a long time.",
    },
  ];

  const pokerdevcompany = [
    {
      title: "  Cutting- Edge Technology Integration    ",
      icon: Cutting,
      desc: "We work the rearmost technologies including advanced physics engines, real- time  ray tracing, AI- driven gameplay systems, and high- performance plates optimization to produce coming- generation hall gaming gests . Our specialized moxie spans Unity 3D, Unreal Engine 5, custom C machines, React Native, and enterprise cloud infrastructure.   ",
    },
    {
      title: "  High- Performance Optimization & Smooth Gameplay    ",
      icon:  Design_ ,
      desc: "   Raiden Labs implements advanced optimization ways and performance profiling to insure harmonious 60 FPS gameplay across all target platforms. Our specialized protocols include memory operation optimization, GPU acceleration, network latency minimization, and real- time performance monitoring for flawless hall gests    ",
    },
    {
      title: "   Global Market Expertise   ",
      icon: Global_Market_Expertise,
      desc: "  Our platoon understands different gaming requests across the USA, Japan, Europe, Asia, and arising homes. We insure your hall game comply with platform conditions, artistic preferences, age standing guidelines, and monetization regulations for successful global launches across all major gaming platforms    ",
    },
    {
      title: "   Advanced Multiplayer Architecture   ",
      icon: Testing_,
      desc: "  We specialize in creating high- performance real- time multiplayer hall systems that support thousands of concurrent players with minimum quiescence. Our scalable garçon structure ensures instant matchmaking, real- time leaderboards, event operation, and flawlesscross-platform competition.    ",
    },
    {
      title: "    AI- Powered Gaming Intelligence  ",
      icon: Powered_Gaming_Intelligence,
      desc: " Our AI- driven results enhance player engagement through adaptive difficulty systems, substantiated content recommendations, intelligent bot opponents, and behavioral analysis.  machine learning algorithms continuously optimize gameplay balance, retention mechanics, and monetization strategies to maximize player continuance value.     ",
    },
  ];

  const gamedevservices = [
    {
      title: "Unreal Engine Development",
      icon:Unreal_Engine_Development ,
      desc: " Our mastery of Unreal Engine enables us to produce games with excellent performance and fidelity. Our pipeline offers realistic rendering, advanced physics, and scalable multiplayer architectures, and it works with both PC and console platforms.",
      link: "/unreal-engine-game-development",
    },
    {
      title: "Poker  Game Development  ",
      icon: Poker_Game_Development,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon:Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon: Ludo_Game_Development ,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon: Rummy_Game_Development,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  const custom = [
    {
      icon: Multiple_games,
      title: "    Multiple Game genres",
      desc: "  Action shooters for violent combat, puzzle games for strategic thinking, and classic classics for nostalgic gameplay. Each order offers unique mechanics, scoring systems, and difficulty progressions, catering to different player preferences and skill situations.   ",
    },
    {
      icon: Real_time,
      title: "  Real-time Multiplayer  ",
      desc: "Competitions Connect and contend with players worldwide through flawless real-time multiplayer functionality that ensures accompanied gameplay with instant score updates and pause-free performance across all game modes    ",
    },
    {
      icon: Achivement,
      title: "  Achievement & jewel System  ",
      desc: "  Unlock prices and showcase your gaming prowess through comprehensive achievement systems that track player progress, corner completions, and skill-grounded accomplishments. Advanced jewel collections with rare and fabulous achievements for devoted players.    ",
    },
    {
      icon: socail_media,
      title: "   Social Media Integration ",
      desc: "  Share your high scores, invite friends, and show achievements directly through integrated social media platforms, including Facebook, Twitter, and Instagram. produce viral moments with instant gameplay clips and leaderboard screenshots.   ",
    },
    {
      icon: cross_platform,
      title: "Cross-Platform compatibility     ",
      desc: "    Play seamlessly across all bias, including smartphones, tablets, web browsers, and gaming consoles, while maintaining your progress, high scores, and achievements through platform synchronization with instant device switching. ",
    },
  ];

  const technologies = [
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  Frontend",
      desc: "Swift",
      desc2: " Flutter",
      desc3: " React Native",
    },

    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Backend ",
      desc: " Node.js",
      desc2: " Python",
      desc3: " .NET Core",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Databases  ",
      desc: "PostgreSQL ",
      desc2: " MongoDB",
      desc3: " Firebase",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Cloud & Hosting  ",
      desc: " AWS",
      desc2: " Google Cloud",
      desc3: " Azure",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  APIs & Integrations",
      desc: " GraphQL",
      desc2: " SOAP",
      desc3: "Twilio ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Testing Tools ",
      desc: " Appium",
      desc2: " Selenium",
      desc3: " Anti-Fraud System",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "DevOps & CI/CD  ",
      desc: " GitLab CI/CD",
      desc2: " Jenkins",
      desc3: " Docker",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  Analytics & Monitoring",
      desc: " Google Analytics",
      desc2: " Firebase Analytics",
      desc3: " Sentry",
    },
  ];

  const card = [
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "mobile",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "PC ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "TABLET ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "CONSOLE",
    },
  ];

  const clientexp = [
    {
      icon:Maskgroup ,
      name: "sherin",

      desc: "Working with Raiden Labs has been a big success for our business.Their team of expert game developers took the time to understand our vision and delivered a high-quality game that exceeded our expectations. From the initial idea to the global launch, everything was done perfectly. We’re very happy to have partnered with a trusted game development company that truly understands the fast-paced gaming industry. We highly recommend Raiden Labs for any game development needs! ",
    },
    {
      icon:Maskgroup3 ,
      name: "Jack  ",
      undername: " ",
      desc: "From the start, Raiden Labs showed great skill and dedication.As a company looking for a strong game development partner, we needed someone who could guide us through the challenges of creating a high-performance game that works across different platforms. With their experience, the team gave smart advice and ensured a smooth launch on all major platforms. Our game is now more engaging than ever, and our players enjoy smooth, 60 FPS gameplay. Choosing Raiden Labs as our game development company was one of the best decisions we made.",
    },
    {
      icon:Maskgroup2 ,
      name: "  Domnick",
      undername: "  ",
      desc: "We had a great experience with Raiden Labs!Their game development services turned our idea into a beautiful, addictive game. The fact that they are a trusted game development company gave us confidence, and their team’s expertise was clear in every step of the process. Their focus on performance and attention to gameplay details is unmatched. Now we have a scalable, high-performance game that stands out in the competition. ",
    },
  ];
  const handleClick=(e)=>{
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    console.log("data subitted successfully")
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"      style={{ minHeight: "100vh"}}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">
              Arcade Game Development Company
            </h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              Raiden Labs is a trusted Arcade Game Development company that
              offers dynamic, scalable Arcade Gaming results. We deliver
              immersive, action- packed hall games using advanced technologies
              to boost engagement and stoner retention.
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
          <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className=" col-lg-6 text-center mb-3">
            <img src={big} style={{ width: "85%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Our Arcade Game Development results
            </h2>
            <p className="mt-4  h1-para" >
              Raiden Labs is a leader in Arcade Game Development Services,
              integrating AI, blockchain, and cutting-edge plates to produce
              thrilling gaming gests across web, mobile, PC, and consoles. Our
              customized  Arcade Game Development results insure presto- paced,
              scalable, and addicting gameplay. With a strong focus on
              innovative mechanics and player satisfaction, we're reconsidering
              assiduity norms. Partner with us to enhance your gaming portfolio.
              We produce Innovative Features
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                 easily distribute in multiple currencies
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                High- score systems with global leaderboards
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Ensures addicting gameplay with progressive difficulty
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">
          Our End-to-End Arcade Game Development Services
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          Raiden Labs prides itself on utilizing the latest tools and frameworks
          to ensure our games are not only beautiful and fun but also stable,
          secure, and future-proof.
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Features We Provide in Arcade Games
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            Our Arcade game service includes the best features so that the
            player can feel the modern version of arcade nostalgic gameplay
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row align-items-center ">
            <div className="col-lg-6">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                What We Offer
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Unite with us for bespoke hall software finagled for high
                performance, scalability, and an stimulating player experience.
                From conception and character design to multiplayer armature and
                live deployment, we deliver the complete technology stack so you
                can launch, contend, and dominate in any request.{" "}
              </p>

              <Link to="/request-quote">
                <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                  TALK WITH OUR EXPERTS NOW!
                </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon} alt="" className="img-big-game"/>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            The Raiden Edge: Advanced Tech and a Flawless Arcade
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge Arcade gameplay 
            experience.
          </p>
          <CoreComponent32 />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal Arcade: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your Unity app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37 />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row align-items-center ">
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Secure Your Digital World
              </h2>
              <p
                className="h1-para text-white  lh-base"
                style={{ opacity: 0.6 }}
              >
                Protect your business from threats. Our security specialists
                provide robust solutions to safeguard your data and fortify your
                infrastructure, giving you peace of mind.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon2} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">Our Development Methodology</h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          Our process focuses on transforming an initial concept into a finished
          product, building a compelling world and story while engineering the
          underlying technology, and finalizing the experience with
          comprehensive audio and a strategic launch plan.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 ">
        <h2 className="text-center lh-base h2-heading ">
          Why Raiden Labs is the Stylish Arcade Game Development Company
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          We are able to translate complicated concepts into dependable, useful
          frameworks for understanding technical and  industry-specific demands.
          Our comprehensive understanding benefits customers by ensuring
          reliable and effective solutions.{" "}
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-80 ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          Hear directly from those who've partnered with us. These testimonials
          reflect Raiden Labs' commitment to excellence, innovation, and client
          satisfaction in Unreal Engine game creation.
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ArcadeGameDev;
